import { useQuery } from 'react-query'
import { fetchExpertMentors } from '../apis/api.assignation'
import { useTeam } from '../pages/Team/Context/TeamContext'
import { useMyCourse } from './ApiHooks/useCourses'

export const queryKeyHRExpertMentors = ['Expert Mentors', 'Status']

export const useHRExpertMentors = () => {
    const { courseID, team } = useTeam()
    const course = useMyCourse(courseID)

    // Prioritize data from team context if available, fallback to course query
    const helpRequestType = team?.courseFlags?.helpRequestType || course?.courseFlags?.helpRequestType
    const useMentor = helpRequestType === 'mentor'

    const { data, ...rest } = useQuery({
        queryKey: queryKeyHRExpertMentors,
        queryFn: fetchExpertMentors,
        staleTime: 1000 * 60 * 3, // 3 minutes
        enabled: useMentor,
    })

    return { ...data, ...rest }
}
